import {
  BadgeCell,
  type BadgeCellComponentProps,
  Column,
} from '@odin-labs/components';
import { ConnectorStatus } from 'apollo/generated/client-operations';
import type { ConnectorListItem } from './connectorTypes';

export type ConnectorColumn = Column<ConnectorListItem>;

const getConnectorStatus = (
  connector: ConnectorListItem,
): BadgeCellComponentProps => {
  switch (connector.status) {
    case ConnectorStatus.Draft:
      return { color: 'gray', text: 'Draft', size: 'lg' };
    case ConnectorStatus.Connecting:
      return { color: 'yellow', text: 'Connecting', size: 'lg' };
    case ConnectorStatus.ConnectionFailed:
      return { color: 'red', text: 'Connection failed', size: 'lg' };
    case ConnectorStatus.Connected:
      return { color: 'yellow', text: 'Connected', size: 'lg' };
    case ConnectorStatus.Enabling:
      return { color: 'yellow', text: 'Enabling', size: 'lg' };
    case ConnectorStatus.EnablementFailed:
      return { color: 'red', text: 'Enablement failed', size: 'lg' };
    case ConnectorStatus.Enabled:
      return { color: 'green', text: 'Enabled', size: 'lg' };
    case ConnectorStatus.Disabled:
      return { color: 'gray', text: 'Disabled', size: 'lg' };
    default: {
      const unsupportedStatus: never = connector.status;
      throw new Error(`Unsupported Connector status: ${unsupportedStatus}`);
    }
  }
};

export const getColumns = (): ConnectorColumn[] => [
  {
    id: 'type',
    Header: 'Connector',
    accessor: (connector): string => connector.definition.displayName,
  },
  {
    id: 'status',
    Header: 'Status',
    accessor: (connector): string => connector.status,
    Cell: BadgeCell,
    componentProps: getConnectorStatus,
  },
];
